<div class="bids-section" *ngIf="cargoRequestId != null">
  <h2>{{ bidsSectionTitleText }}</h2>

  <div *ngIf="loadingBids" class="loading-bids">
    {{ loadingBidsText }}
  </div>

  <div *ngIf="errorBids" class="error-message">
    {{ errorBids }}
  </div>

  <div *ngIf="!loadingBids && !errorBids && bids.length === 0" class="no-bids">
    {{ noBidsText }}
  </div>

  <!-- Выгода от конкурса — после выбора экспедитора -->
  <div class="bids-gain" *ngIf="gain as g">
    <span class="bids-gain__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 17l6-6 4 4 8-8M15 7h6v6"/></svg></span>
    <span>
      {{ t('coOverview.gainLine1', 'Вы выбрали ставку на') }} <b>{{ gainMoney(g.gain) }}</b> {{ t('coOverview.gainLine2', 'дешевле средней') }}
      <small>{{ t('coOverview.gainLine3', 'по остальным ставкам') }}: {{ g.others }}</small>
    </span>
  </div>

  <div *ngIf="!loadingBids && !errorBids && bids.length > 0" class="bids-table-container">
    <table class="bids-table">
      <thead>
        <tr>
          <th>{{ bidNumberText }}</th>
          <th *ngIf="bidViewRoutePrefix === 'customs-broker'">{{ forwarderText }}</th>
          <th>{{ priceText }}</th>
          <th>{{ priceKztText }}</th>
          <th>{{ deliveryDaysText }}</th>
          <th>{{ statusText }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let bid of bids"
          class="bid-row"
          [class.bid-row--best]="bid.bestPrice && bid.bidStatus !== 'LOST'"
          (click)="viewBid(bid.id)"
        >
          <td class="bid-id">
            {{ bid.id | docNo:'B':bid.createdAt }}
            <span *ngIf="bid.bestPrice && bid.bidStatus !== 'LOST'" class="best-badge">{{ bestBidText }}</span>
          </td>
          <td *ngIf="bidViewRoutePrefix === 'customs-broker'">{{ bid.freightForwarderCompanyName }}</td>
          <td>{{ bid.price | number:'1.2-2' }} {{ bid.currencyCode }}</td>
          <td class="price-kzt">
            <ng-container *ngIf="bid.priceKzt != null">
              ≈ {{ bid.priceKzt | number:'1.2-2' }} ₸
            </ng-container>
            <ng-container *ngIf="bid.priceKzt == null">—</ng-container>
          </td>
          <td>{{ bid.deliveryDays }} {{ daysText }}</td>
          <td>
            <span class="status-badge" [class]="'status-' + getBidStatusClass(bid)">
              {{ getBidStatusText(bid) }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
